var _defs, _rect, _rect2, _circle, _text, _text2, _rect3, _circle2, _text3, _text4, _rect4, _circle3, _text5, _text6, _rect5, _circle4, _text7, _text8, _rect6, _circle5, _text9, _text0, _rect7, _text1, _text10, _text11, _rect8, _rect9, _text12, _text13, _rect0, _rect1, _text14, _text15, _rect10, _rect11, _text16, _rect12, _circle6, _text17, _text18, _text19, _rect13, _circle7, _text20, _rect14, _circle8, _text21, _text22, _text23, _rect15, _circle9, _text24, _rect16, _circle0, _text25, _text26, _text27, _rect17, _circle1, _text28, _rect18, _circle10, _text29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportCommandCentreWorkforceReadinessDashboardMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 1420,
    viewBox: "0 0 620 1420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work Passport command centre mobile dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-cc-mobile-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FD"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 584,
    height: 1384,
    rx: 34,
    fill: "url(#wp-cc-mobile-bg)",
    stroke: "#29405D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 46,
    width: 532,
    height: 72,
    rx: 18,
    fill: "#07152A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 82,
    r: 8,
    fill: "#30D6A1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 101,
    y: 77,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 21,
    fontWeight: 850
  }, "Workforce readiness")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 101,
    y: 100,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 650
  }, "All active sites \xB7 Live view")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 146,
    width: 254,
    height: 128,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 174,
    r: 6,
    fill: "#087CFF"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 223,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 38,
    fontWeight: 880
  }, "486")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 250,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820,
    letterSpacing: 1
  }, "TOTAL WORKFORCE")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 146,
    width: 254,
    height: 128,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 174,
    r: 6,
    fill: "#30D6A1"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 338,
    y: 223,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 38,
    fontWeight: 880
  }, "412")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 338,
    y: 250,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820,
    letterSpacing: 1
  }, "READY")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 296,
    width: 254,
    height: 128,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 324,
    r: 6,
    fill: "#F5B642"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 373,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 38,
    fontWeight: 880
  }, "48")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 400,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820,
    letterSpacing: 1
  }, "EXPIRING SOON")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 296,
    width: 254,
    height: 128,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 324,
    r: 6,
    fill: "#FF6B67"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 338,
    y: 373,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 38,
    fontWeight: 880
  }, "26")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 338,
    y: 400,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820,
    letterSpacing: 1
  }, "ACTION REQUIRED")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 476,
    width: 532,
    height: 280,
    rx: 22,
    fill: "#07152A"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 518,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.3
  }, "SITE READINESS")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 560,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 760
  }, "North Processing Plant")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 560,
    textAnchor: "end",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 850
  }, "92%")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 578,
    width: 476,
    height: 8,
    rx: 4,
    fill: "#203854"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 578,
    width: 438,
    height: 8,
    rx: 4,
    fill: "#30D6A1"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 622,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 760
  }, "East Shaft")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 622,
    textAnchor: "end",
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 850
  }, "78%")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 640,
    width: 476,
    height: 8,
    rx: 4,
    fill: "#203854"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 640,
    width: 371,
    height: 8,
    rx: 4,
    fill: "#F5B642"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 684,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 760
  }, "West Works")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 684,
    textAnchor: "end",
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 850
  }, "63%")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 702,
    width: 476,
    height: 8,
    rx: 4,
    fill: "#203854"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 702,
    width: 300,
    height: 8,
    rx: 4,
    fill: "#FF6B67"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 814,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.3
  }, "EMPLOYEE READINESS")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 844,
    width: 532,
    height: 126,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 907,
    r: 27,
    fill: "#30D6A1",
    fillOpacity: 0.13
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 914,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 850
  }, "TM")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 137,
    y: 894,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 840
  }, "Thabo Mokoena")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 137,
    y: 923,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "North Plant \xB7 Technician")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 888,
    width: 108,
    height: 38,
    rx: 19,
    fill: "#30D6A1",
    fillOpacity: 0.12
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 907,
    r: 5,
    fill: "#30D6A1"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 472,
    y: 912,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "READY")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 994,
    width: 532,
    height: 126,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 1057,
    r: 27,
    fill: "#F5B642",
    fillOpacity: 0.13
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 1064,
    textAnchor: "middle",
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 850
  }, "LN")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 137,
    y: 1044,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 840
  }, "Lerato Nkosi")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 137,
    y: 1073,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "East Shaft \xB7 Operator")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 1038,
    width: 108,
    height: 38,
    rx: 19,
    fill: "#F5B642",
    fillOpacity: 0.12
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 1057,
    r: 5,
    fill: "#F5B642"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 472,
    y: 1062,
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "18 DAYS")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 1144,
    width: 532,
    height: 126,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 1207,
    r: 27,
    fill: "#FF6B67",
    fillOpacity: 0.13
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 1214,
    textAnchor: "middle",
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 850
  }, "SM")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 137,
    y: 1194,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 840
  }, "Sipho Maseko")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 137,
    y: 1223,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "West Works \xB7 Supervisor")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 1188,
    width: 108,
    height: 38,
    rx: 19,
    fill: "#FF6B67",
    fillOpacity: 0.12
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 1207,
    r: 5,
    fill: "#FF6B67"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 472,
    y: 1212,
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "ACTION")), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 1324,
    width: 532,
    height: 52,
    rx: 14,
    fill: "#E7F8F2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 1350,
    r: 6,
    fill: "#30D6A1"
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 1356,
    fill: "#08755A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 820
  }, "Live status based on current evidence and allocation")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportCommandCentreWorkforceReadinessDashboardMobile);
export default __webpack_public_path__ + "static/media/work-passport-command-centre-workforce-readiness-dashboard-mobile.155415162b5e852b0bcaf7610178e562.svg";
export { ForwardRef as ReactComponent };